module.exports = __webpack_public_path__ + "img/gh-12132____-3541.prt.6249cd04.jpg";